// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1LyDl","header":"ReportDetails_header__1NtMu","title":"ReportDetails_title__QRzQY","left":"ReportDetails_left__3Spcz"};